import React, {Component} from 'react';
import * as SwaggerUI from 'swagger-ui/dist/swagger-ui.js';
import StandalonePreset from 'swagger-ui/dist/swagger-ui-standalone-preset';
import 'swagger-ui/dist/swagger-ui.css';
import '../css/topbar.css'
import * as specs from '../specs';

class SwaggerUIWrapper extends Component {

    componentDidMount() {
        SwaggerUI({
            dom_id: '#swaggerContainer',
            urls: specs,
            deepLinking: true,
            validatorUrl: null,
            filter: true,
            presets: [
                SwaggerUI.presets.apis,
                StandalonePreset
            ],
            layout: "StandaloneLayout"
        });
    }

    render() {
        return (
            <div id="swaggerContainer" />
        );
    }
}

export default SwaggerUIWrapper;
